module.exports = __webpack_public_path__ + "assets/img/icon0.445eca05.png";